import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';
import { upTo } from 'js/services/MediaQuery';

import { breakpoint } from '../Grid';
export const height = '3rem';
export const menuBreakpoint = '800px';

export default styled.div`
  font-weight: 500;
  line-height: ${`calc(${height} - 1px)`};
  position: relative;
  border-bottom: 1px solid ${lightGrey2Color};
  grid-area: header;
  display: grid;
  color: black;
  grid-template-columns: 1fr auto auto;
  grid-template-areas: 'title controls';

  ${upTo(breakpoint)`
    padding-left: 0;
    grid-template-columns: auto 1fr auto auto;
    grid-template-areas: 'menu title controls';
  `}

  ${upTo(menuBreakpoint)`
    grid-template-columns: auto 1fr;
    grid-template-areas:
      'menu title'
      'controls controls';
  `}
`;
